"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.riskBarClass = riskBarClass;
exports.shouldBlink = shouldBlink;
exports.statusBarClass = statusBarClass;
var _react = _interopRequireDefault(require("react"));
var _DeviationScoreBar = require("@common/components/review/DeviationScoreBar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var NEUTRAL_BAR_CLASS = "bg-foreground-muted";
var RESOLVED_BAR_CLASS = "bg-success";
var FAILED_BAR_CLASS = "bg-destructive";
var STAGE_PROGRESS = {
  queued: {
    detectionProgress: 10,
    remedyProgress: 0,
    isDetectionPhase: true,
    isRemedyPhase: false,
    isCompleted: false
  },
  detection: {
    detectionProgress: 25,
    remedyProgress: 0,
    isDetectionPhase: true,
    isRemedyPhase: false,
    isCompleted: false
  },
  "in-progress": {
    detectionProgress: 50,
    remedyProgress: 0,
    isDetectionPhase: false,
    isRemedyPhase: true,
    isCompleted: false
  },
  remedy: {
    detectionProgress: 50,
    remedyProgress: 25,
    isDetectionPhase: false,
    isRemedyPhase: true,
    isCompleted: false
  },
  done: {
    detectionProgress: 50,
    remedyProgress: 50,
    isDetectionPhase: false,
    isRemedyPhase: false,
    isCompleted: true
  },
  error: {
    detectionProgress: 50,
    remedyProgress: 50,
    isDetectionPhase: false,
    isRemedyPhase: false,
    isCompleted: true
  },
  skipped: {
    detectionProgress: 50,
    remedyProgress: 50,
    isDetectionPhase: false,
    isRemedyPhase: false,
    isCompleted: true
  }
};
function bottomBarHeight(state, responded, conceded) {
  if (responded || conceded) {
    if (state.isCompleted) return "50%";
    if (state.isDetectionPhase) return "".concat(Math.min(state.detectionProgress, 50) / 2, "%");
    if (state.isRemedyPhase) return "".concat(25 + Math.min(state.remedyProgress, 50) / 2, "%");
    return "0%";
  }
  if (state.isCompleted) return "100%";
  if (state.isDetectionPhase) return "".concat(Math.min(state.detectionProgress, 50), "%");
  if (state.isRemedyPhase) return "".concat(50 + Math.min(state.remedyProgress, 50), "%");
  return "0%";
}
function topBarHeight(state, responded, conceded) {
  if (!responded && !conceded) return "0%";
  if (state.isCompleted) return "50%";
  if (state.isDetectionPhase) return "".concat(Math.min(state.detectionProgress, 50) / 2, "%");
  if (state.isRemedyPhase) return "".concat(25 + Math.min(state.remedyProgress, 50) / 2, "%");
  return "0%";
}
function riskBarClass(stage, importance, match, responded, conceded) {
  if (stage === "queued" || stage === "detection" || stage === "skipped") return NEUTRAL_BAR_CLASS;
  if (stage === "error") return FAILED_BAR_CLASS;
  if (match || responded || conceded) return _DeviationScoreBar.SEGMENT_BAR_CLASS[importance];
  if (stage === "done") return _DeviationScoreBar.SEGMENT_BAR_CLASS.compliant;
  return NEUTRAL_BAR_CLASS;
}
function statusBarClass(responded, conceded) {
  return responded || conceded ? RESOLVED_BAR_CLASS : NEUTRAL_BAR_CLASS;
}
function shouldBlink(stage) {
  return !STAGE_PROGRESS[stage].isCompleted;
}
function IssueStageProgressBar(_ref) {
  var stage = _ref.stage,
    importance = _ref.importance,
    match = _ref.match,
    responded = _ref.responded,
    conceded = _ref.conceded;
  var state = STAGE_PROGRESS[stage];
  var blinking = shouldBlink(stage);
  var pulse = blinking ? "animate-issue-stage-pulse" : "";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "absolute left-0 bottom-0 h-full w-1 transition-[height] duration-300 ease-out z-[1] pointer-events-none ".concat(NEUTRAL_BAR_CLASS, " ").concat(pulse)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "absolute left-0 bottom-0 w-1 transition-[height] duration-300 ease-out z-[2] pointer-events-none ".concat(riskBarClass(stage, importance, match, responded, conceded), " ").concat(pulse),
      style: {
        height: bottomBarHeight(state, responded, conceded)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "absolute left-0 top-0 w-1 transition-[height] duration-300 ease-out z-[3] pointer-events-none ".concat(statusBarClass(responded, conceded), " ").concat(pulse),
      style: {
        height: topBarHeight(state, responded, conceded)
      }
    })]
  });
}
var _default = exports.default = IssueStageProgressBar;